import React, { Component } from 'react'
import Axios from 'axios';
import { MDBBtn, MDBIcon, MDBCard, MDBCardBody, MDBContainer, MDBBox, MDBAlert   } from 'mdbreact';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import Modalregister from './Modalregister';
import Modalfinance from './Modalfinance';
import Commentbnlistforuser from './Commentbnlistforuser';
import Commentexlistforuser from './Commentexlistforuser';
import { URL,api } from '../api';
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip, PageHeader  } from 'antd';
import Modalregisterlestten from './Modalregisterlestten';
import ban from '../img/math.png'
import Modaluserpay from './Modaluserpay';





export default class Homeuserlisten extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: '',
            Psaaword:'',
            modal: false,
            iduser:'',
            article:[],
            articlepay:[],
            url:'https://mua.kpru.ac.th/FrontEnd_Conferencekpru/',
        };
       
        this.submit = this.submit.bind(this);
        this.list = this.list.bind(this);
       // this.toggle = this.toggle.bind(this);
      }


    onTextChange = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

    submit = (event) => {
        event.preventDefault();

        var datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
        datafrm.append("id", this.state.id);
        datafrm.append("name", this.state.name);
        datafrm.append("lname", this.state.lname);
        datafrm.append("age", this.state.age);
        datafrm.append("sex", this.state.sex);

        if (this.state.update === false) { //เช็คว่าเป็นหน้าสำหรับอัพเดตหรือไม่
            Axios.post('https://conference.kpru.ac.th/PHP/insert.php', datafrm)
                .then((res) => {
                    this.props.history.push('/Customers') //เมื่อบันทึกเสร็จจะทำการให้เปลี่ยนไปที่ path Customers
                })
                .catch((err) => { alert("ไม่สำเร็จ " + err) })

        }
        else {
            Axios.post('https://conference.kpru.ac.th/PHP/update.php', datafrm)
                .then((res) => {
                    this.props.history.push('/Customers') //เมื่อบันทึกเสร็จจะทำการให้เปลี่ยนไปที่ path Customers
                })
                .catch((err) => { alert("ไม่สำเร็จ " + err) }) // เมื่อเกิด error จะมาทำที่คำสั่งนี้แทน
        }

    }

    componentDidMount() {
        this.setState({ iduser: localStorage.getItem('iduser')})


        setTimeout(() => {
            //ภายใน
            api.get('registercon/selecttextforuserlist/'+localStorage.getItem('iduser'))
            .then(res => {
              console.log(res);
            //  this.setState({ bankname: res.data, loading: false })
              this.setState({ article: res.data})
            }) 
      
          }, 0);

          setTimeout(() => {
            //ภายใน
            api.get('registercon/selecttextforuserlist/'+localStorage.getItem('iduser'))
            .then(res => {
              console.log(res);
            //  this.setState({ bankname: res.data, loading: false })
              this.setState({ articlepay: res.data})
            }) 
      
          }, 0);

      
    }

    list() {
        this.setState({ iduser: localStorage.getItem('iduser')})


        setTimeout(() => {
            //ภายใน
            api.get('registercon/selecttextforuserlist/'+localStorage.getItem('iduser'))
            .then(res => {
              console.log(res);
            //  this.setState({ bankname: res.data, loading: false })
              this.setState({ article: res.data})
            }) 
      
          }, 0);

          setTimeout(() => {
            //ภายใน
            api.get('registercon/selecttextforuserlist/'+localStorage.getItem('iduser'))
            .then(res => {
              console.log(res);
            //  this.setState({ bankname: res.data, loading: false })
              this.setState({ articlepay: res.data})
            }) 
      
          }, 0);

      
    }


    render() {

        const date = new Date();
        const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
        const dates = day+"-"+month+"-"+year ;

        console.log(dates)


        return (

            <MDBContainer className="mt-1 " fluid>
                 
                 {/* <img src={ban} className="rounded  d-block "alt="aligment" /> */}
        
                <MDBCard>
                    
                    <MDBCardBody>
                        {/* <h1>{this.state.update === true ? <>อัพเดตข้อมูลสมาชิก</> : <>เพิ่มสมาชิก</>}</h1> */}
                      <div className='text-right font-weight-bold'><p>สวัสดีคุณ{localStorage.getItem('nameuser')}</p></div>  
                        
                     <div className='mb-2 mt-2'> <Modalregisterlestten iduser={this.state.iduser} list={this.list} /></div>  
                     {/* <MDBAlert color="success" >
                      <MDBBox tag="p"><h4><strong>รายการลงทะเบียนเข้าร่วมรับฟังการนำเสนอ</strong></h4></MDBBox>
                     </MDBAlert> */}
                            <MDBAlert color="secondary" >
                                    <PageHeader
                                    className="site-page-header"
                                // onBack={() => null}
                                    title="รายการลงทะเบียนเข้าร่วมรับฟังการนำเสนอ"
                                    subTitle=""
                                    avatar={{ src: 'https://cdn-icons-png.flaticon.com/512/4514/4514882.png' }}
                                />
                            </MDBAlert>    
                        
                           

                             <MDBTable bordered responsive small>
                                    <MDBTableHead color="grey darken-1" textWhite>
                                        <tr>
                                        <th>ลำดับ</th>
                                        <th>ชื่อผู้เข้าร่วมฟัง</th>
                                        <th>หน่วยงาน</th>
                                        <th>เบอร์โทร</th>
                                        <th>เลขที่ผู้เสียภาษีของหน่วยงาน</th>
                                        <th>ที่อยู่แสดงในใบเสร็จ</th>
                                        <th>วันที่ทำรายการ</th>
                                        <th>ชำระเงิน</th>
                                        
                                        {/* <th>หลักฐาน</th> */}
                                        </tr>
                                    </MDBTableHead>
                                    <MDBTableBody>
                                    {this.state.article.map((article,index )  => 
                                    <tr>
                                    <td>{index+1}</td>
                                    <td>{article.pnamelisten}{article.namelisten} {article.lnamelisten}</td>
                                    <td>{article.agencylisten}</td>
                                    <td>{article.tellisten}</td>
                                    <td>{article.registerlisten_taxnumber}</td>
                                    <td>{article.registerlisten_taxadress} {article.registerlisten_taxDISTRICT} {article.registerlisten_taxAMPHUR} {article.registerlisten_taxPROVINCE	}  {article.registerlisten_taxCODE		}  </td>
                                    <td>{article.sendlisten_date}</td>
                                    <td>
                                    {article.external_typelisten	=== '3' || article.external_typelisten	=== '4' || article.external_typelisten	=== '5' || article.external_typelisten=== '6' ?<>
                                        {article.creck	=== '0'?<>
                                          <Modaluserpay id_send={article.id_listen} send_id={article.send_id} typeac_id={3} price_typeregister={article.price_typeregister} list={this.list}/>
                                        </>:<>
                                        <MDBContainer className='text-left'><a href={`https://e-finance.kpru.ac.th/receipt_research?customer_id=${article.ref1}&receipt_book=${article.BOOK}&receipt_no=${article.NO}`}><MDBBtn color="unique" size='sm'>พิมพ์ใบเสร็จ</MDBBtn></a></MDBContainer> 

                                        </>} 
</>:<>

<p className="teal-text"> ฟรี</p>
</>}
                                      {/* <Modaluserpay id_send={article.id_listen} send_id={article.send_id} typeac_id={3} price_typeregister={article.price_typeregister} list={this.list}/> */}
                                      </td>
                          
                                    
                                  
                                    </tr>
                                )}
                           
                                    </MDBTableBody>
                            </MDBTable>


                            {/* <MDBAlert color="success" >
                            <MDBBox tag="p"><h4><strong>ตรวจสอบสถานะบทความ</strong></h4></MDBBox>
                             </MDBAlert>
   

                    <MDBTable bordered responsive>
                        <MDBTableHead color="grey darken-1" textWhite>
                            <tr>
                            <th>ลำดับ</th>
                            <th>ชื่อบทความ</th>
                            <th>ผู้นำเสนอ</th>
                            <th>ประเภท</th>
                            <th>ข้อเสนอแนะบรรณาธิการ</th>
                            <th>ข้อเสนอแนะผู้ทรงคุณวุฒิ</th>
                            <th>สถานะ</th>
                            </tr>
                        </MDBTableHead>
                        <MDBTableBody>
                        {this.state.articlepay.map((articlepay,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{articlepay.name_article}</td>
                        <td>{articlepay.name_present}</td>
                        <td>{articlepay.presentype_name }</td>
                        <td><Commentbnlistforuser  id_send={articlepay.id_send} iduser={this.state.iduser}/></td>
                        <td>
                       
                          <Commentexlistforuser  id_send={articlepay.id_send} iduser={this.state.iduser}/>
                          </td>
                        <td>{articlepay.stapat === '3'?<>    <MDBAlert color="success">
        <a href="#!" className="alert-link">ผ่านการพิจารณา</a>
      </MDBAlert></>:<><MDBAlert color="warning">
        <a href="#!" className="alert-link">อยู่ระหว่างการพิจารณา</a>
      </MDBAlert></>}

      {articlepay.stapat === '3'?<>   
      <MDBBtn color="secondary" size="sm" href={'https://conference.kpru.ac.th/PHPAPI/TCPDF-main/certificate.php?id_sendcf='+articlepay.id_send } target="_blank"> ดาวน์โหลดเกียรติบัตร</MDBBtn>
      </>:<></>}
      </td>
                        </tr>
                      )}
                           
                        </MDBTableBody>
                    </MDBTable> */}

                     
                    </MDBCardBody>
                   <hr/>
                    {/* <img src="https://conference.kpru.ac.th/PHPAPI/rerip.png" className="rounded mx-auto d-block w-50" alt="aligment" /> */}
                </MDBCard>
                </MDBContainer>
        )
    }
}

